import { render, staticRenderFns } from "./SurfacePostBody.vue?vue&type=template&id=a2d9f282&"
import script from "./SurfacePostBody.vue?vue&type=script&lang=ts&"
export * from "./SurfacePostBody.vue?vue&type=script&lang=ts&"
import style0 from "./SurfacePostBody.vue?vue&type=style&index=0&id=a2d9f282&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports